module.exports = __webpack_public_path__ + "img/Weapon_119.28259d07.png";